// removed by extract-text-webpack-plugin
module.exports = {"content":"ServiceList__content___biCO7","border":"ServiceList__border___Jafim"};